import { Descriptions } from 'antd';
import { isEmpty } from 'lodash';
import React from 'react';
import MyUtil from '../../functions/MyUtil';

const PartnerInfo = {
  Basic(props) {
    const { partner } = props;

    return (
      <Descriptions bordered column={4} size="small" title="Thông tin cơ bản">
        <Descriptions.Item label="Thành phố">
          {partner['city_name']}
        </Descriptions.Item>
        <Descriptions.Item label="Đối tác">
          {partner['part_name']}
        </Descriptions.Item>
        <Descriptions.Item label="Địa điểm" span={2}>
          {partner['part_addr']}
        </Descriptions.Item>
        <Descriptions.Item label="Hotline">
          {partner['part_phon']}
        </Descriptions.Item>
        <Descriptions.Item label="Liên hệ">
          {partner['part_ctac_name']} - {partner['part_ctac_mobi']}
        </Descriptions.Item>
        <Descriptions.Item label="Thời gian">
          {partner['part_stat_time']} - {partner['part_end_time']}
        </Descriptions.Item>
      </Descriptions>
    );
  },

  PriceAndFee(props) {
    const { partner } = props;

    function renderWeekDayPrice(partnerWeekDayPrices) {
      if (isEmpty(partnerWeekDayPrices)) {
        return <span>Không có thêm phụ phí các ngày</span>;
      }

      const prices = partnerWeekDayPrices.map((p) => {
        let unit = '%';
        if (p.part_wday_exta_fee > 100) {
          unit = 'VNĐ';
        }
        return (
          <li key={p.wday.wday_name} label={p.wday.wday_name}>
            {p.wday.wday_name}:&nbsp;
            {MyUtil.currencyFormat(p['part_wday_exta_fee'])}
            {unit}
          </li>
        );
      });

      return <ul column={1}>{prices}</ul>;
    }

    return (
      <Descriptions
        bordered
        column={4}
        className="mt-3"
        size="small"
        title="Giá, phí"
      >
        <Descriptions.Item label="Giới hạn km">
          {partner['part_lim_km'] ? partner['part_lim_km'] : null} km
        </Descriptions.Item>
        <Descriptions.Item label="Phụ trội km">
          {partner['part_over_km_fee']
            ? MyUtil.currencyFormat(partner['part_over_km_fee']) + ' VND'
            : null}
        </Descriptions.Item>
        <Descriptions.Item label="Giao xe miễn phí">
          {partner['part_deli_free_km']
            ? partner['part_deli_free_km'] + ' km'
            : '0 km'}
        </Descriptions.Item>
        <Descriptions.Item label="Phí giao xe/km">
          {MyUtil.currencyFormat(partner['part_deli_over_km_fee'])} VND/km
        </Descriptions.Item>
        <Descriptions.Item label="Phí phụ trội theo giờ">
          {MyUtil.currencyFormat(partner['part_over_time_fee'])} VND
        </Descriptions.Item>
        <Descriptions.Item label="Giá cuối tuần">
          {renderWeekDayPrice(partner.part_wdays)}
        </Descriptions.Item>
        <Descriptions.Item label="Giá tăng ngày lễ">
          {partner['part_holis'] &&
            partner.part_holis.map((item) => (
              <div>
                <div style={{ display: 'inline-flex', marginLeft: '40px' }}>
                  <div>
                    -{' '}
                    {item['holi']['holi_name'] +
                      '(' +
                      item['holi']['holi_day_from'] +
                      ' - ' +
                      item['holi']['holi_day_to'] +
                      ')  :'}{' '}
                    &nbsp;
                  </div>
                  <div>
                    <div
                      style={{
                        whiteSpace: 'pre-line',
                        color: 'red',
                        fontWeight: '600',
                      }}
                    >
                      {parseInt(item['part_holi_exta_fee']) >= 1000
                        ? MyUtil.convertMoney(item['part_holi_exta_fee']) +
                          ' VND'
                        : item['part_holi_exta_fee'] + ' %'}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Descriptions.Item>
      </Descriptions>
    );
  },

  Procedure(props) {
    const { partner } = props;

    return (
      <Descriptions column={1} title="Thủ tục" bordered size="small">
        {partner['part_procs'] &&
          partner.part_procs.map((item) => (
            <Descriptions.Item
              label={item.proc.proc_name}
              key={item.proc.proc_name}
            >
              {item.part_proc_note}
            </Descriptions.Item>
          ))}
      </Descriptions>
    );
  },

  Policy(props) {
    const { partner } = props;

    return (
      <>
        <div className="mb-3">
          <strong>Chính sách</strong>
        </div>
        <div style={{ whiteSpace: 'pre-line' }}>{partner['part_polc']}</div>
      </>
    );
  },
};

export default PartnerInfo;
